<template>
  <div class="button-wrapper" :class="btnClass">
    <button
      :type="type"
      :class="btnType"
      :disabled="disabled"
      @click="handleClick"
      v-bind="$attrs"
    >
      <template v-if="icon.length">
        <i :class="[icon, 'mr-2']"></i>
      </template>
      {{ labelText }}
    </button>
  </div>
</template>
<script>
export default {
  name: "default-button",
  props: {
    labelText: {
      type: String,
      default: "Submit",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    btnClass: {
      type: Array,
    },
    btnType: {
      type: Array,
    },
    type: {
      type: String,
      default: "button",
    },
    icon: {
      type: String,
      default: "",
    },
  },
  methods: {
    handleClick(evt) {
      this.$emit("click", evt)
    },
  },
}
</script>
<style>
.button-wrapper button {
  background-color: var(--gfb-blue-brand-500, #0095e2);
  border: none;
  color: white;
  padding: 9px 32px;
  text-decoration: none;
  margin: 2px;
  cursor: pointer;
  border-radius: 8px;
  outline: unset !important;
}
.button-wrapper button:disabled {
  background-color: var(--Gray-200, #d5d9e2);
  color: var(--Gray-400, #8694aa);
  cursor: not-allowed;
}

.right-end {
  margin-left: auto;
  margin-right: 0;
  float: right;
}

.back-btn {
  background-color: #ffffff !important;
  border: 2px solid var(--Blue-500, #4879c9) !important;
  color: var(--Blue-500, #4879c9) !important;
}

.next-btn {
  border: 2px solid #0095e2 !important;
}

button.unsave-btn {
  border: 2px solid var(--Gray-300, #0095e2);
  background: #fff;
  color: var(--gfb-blue-brand-500, #0095e2);
}

button.saved-jobs-btn {
  padding: 8px 16px !important;
  border: 2px solid #0095e2;

  &.unsave-btn {
    padding: 8px 16px !important;
  }
}
button.remove-btn,
button.view-btn {
  padding: 9px 22px;
  border-radius: 8px;
  font-size: 14px;
  cursor: pointer;
  min-width: 120px;
  text-align: center;
}

button.remove-btn {
  background-color: var(--gfb-blue-brand-500, #0095e2);
  border: 2px solid #0095e2;
  color: #fff;
}

button.view-btn {
  border: 2px solid #0095e2;
  background: #fff;
  color: var(--gfb-blue-brand-500, #0095e2);
}

button.cancel-edit-btn {
  border: 2px solid var(--Gray-300, #b0b9c9);
  background: #fff;
  color: var(--Gray-600, #525e77);
  padding: 6px 24px;
}

button.cancel-btn {
  border: 2px solid var(--Gray-300, #b0b9c9);
  background: #fff;
  color: var(--Gray-600, #525e77);
  padding: 7px 24px;
}

button.manage-btn {
  background-color: var(--gfb-blue-brand-500, #0095e2) !important;
}

.apply-btn {
  button {
    width: 100% !important;

    &:disabled {
      background-color: var(--Gray-200, #d5d9e2);
      color: var(--Gray-400, #8694aa);
    }
  }
}
.apply-btn-dashboard {
  button {
    width: 100% !important;
    padding: 9px 22px !important;

    &:disabled {
      background-color: var(--Gray-200, #d5d9e2);
      color: var(--Gray-400, #8694aa);
    }
  }
}

@media (max-width: 370px) {
  .button-wrapper button {
    background-color: var(--gfb-blue-brand-500, #0095e2);
    border: none;
    color: white;
    padding: 9px 13px;
    text-decoration: none;
    margin: 6px 2px;
    cursor: pointer;
    border-radius: 8px;
  }
  button.cancel-btn {
    border: 2px solid var(--Gray-300, #b0b9c9);
    background: #fff;
    color: var(--Gray-600, #525e77);
    padding: 7px 13px;
  }
}
@media (max-width: 1445px) {
  button.view-btn {
    padding: 19px 12px;
  }
}
@media (min-width: 993px) and (max-width: 1236px) {
  button.view-btn {
    padding: 7px 18px; /* smaller padding */
    min-width: 100px; /* shrink width */
    font-size: 13px; /* optional: slightly smaller text */
  }
  button.remove-btn {
    padding: 7px 18px; /* smaller padding */
    min-width: 100px; /* shrink width */
    font-size: 13px; /* optional: slightly smaller text */
  }
}
</style>
